<template>
  <b-table :data="journeys" hoverable>
    <b-table-column
      field="storeName"
      :label="$t('totemJourneys.store')"
      v-slot="props"
      centered
    >
      {{ props.row.storeName || props.row.storeId || "-" }}
    </b-table-column>

    <b-table-column
      field="deviceId"
      :label="$t('totemJourneys.totem')"
      v-slot="props"
      centered
    >
      <p>{{ props.row.deviceId || "-" }}</p>
      <p v-if="props.row.totem">
        <small>
          {{ props.row.totem.manufacturer }} {{ props.row.totem.model }}
        </small>
      </p>
    </b-table-column>

    <b-table-column
      field="startedAt"
      :label="$t('totemJourneys.journeyDate')"
      v-slot="props"
      centered
    >
      {{
        moment
          .utc(props.row.startedAt)
          .add(preferences.timezone, "h")
          .format("DD/MM/YY HH:mm:ss")
      }}
    </b-table-column>

    <b-table-column
      field="transactionIds"
      :label="$t('totemJourneys.transaction')"
      v-slot="props"
      centered
    >
      <p v-if="!props.row.transactionIds.length">-</p>
      <p
        v-for="transactionId in props.row.transactionIds"
        :key="transactionId"
        style="cursor: pointer"
        @click="
          copyContent(transactionId, $t('totemJourneys.transactionIdCopied'))
        "
      >
        <small>{{ transactionId }}</small>
        <b-icon icon="copy" size="is-small"></b-icon>
      </p>
    </b-table-column>

    <b-table-column
      :label="$t('totemJourneys.details')"
      v-slot="props"
      centered
    >
      <b-button
        icon-left="list"
        size="is-small"
        @click="$emit('get-journey-details', props.row)"
      >
        {{ $t("totemJourneys.details") }}
      </b-button>
    </b-table-column>

    <template slot="empty">
      <table-empty-template />
    </template>
  </b-table>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common";
import tableEmptyTemplate from "../common/TableEmptyTemplate";

export default {
  props: ["journeys"],

  mixins: [common],

  components: {
    tableEmptyTemplate
  },

  computed: {
    ...mapGetters(["preferences"])
  }
};
</script>
